export default __webpack_public_path__ + "static/testimony-2-103bf0a8e361de1ef93d300380076b1a.jpg";